/* eslint-disable */
import Vue from 'vue'

Vue.prototype.$events = new Vue()